import { useEffect, useRef, useState } from "react";
import { Box, Stack, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { Variant } from "./Variant";

export const NestedOptions = ({
  regularVariants,
  refillVariants,
  autoDiscount,
  mostPopularVariant,
  options,
  setPickedOption,
  ...props
}) => {
  const [pickedVariant, setPickedVariant] = useState(null);
  const { isReady, query, replace } = useRouter();
  const ref = useRef(true);
  useEffect(() => {
    if (isReady && query.variantId && ref.current) {
      ref.current = false;
      let index = 0;
      regularVariants.forEach((item, i) => {
        const foundOption = item[1]?.find((option) =>
          option?.id?.includes(query.variantId)
        );
        if (foundOption) index = i;
      });
      setPickedVariant(index);
    }
  }, [isReady, query.variantId]);
  const handleClick = (i) => {
    if (i === pickedVariant) {
      setPickedVariant(null);
      setPickedOption(null);
    } else {
      setPickedVariant(i);
      setPickedOption(options[0].values[i]);
    }
    const { variantId, ...rest } = query;
    const route = {
      query: rest,
    };
    replace(route, undefined, { shallow: true });
  };
  return (
    <Box {...props}>
      <Text color={"#767473"} fontSize={"14px"} mb={1}>
        {options[0].name}
      </Text>
      <Stack mb={[2, 2]} space={1} flexDirection={"column"}>
        {regularVariants.map(([key, value], i) => (
          <Variant
            key={key}
            title={key}
            autoDiscount={autoDiscount}
            options={value as any}
            isOpen={pickedVariant === i}
            mostPopularVariant={mostPopularVariant}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleClick(i);
            }}
          />
        ))}
      </Stack>

      {refillVariants && !!refillVariants.length && (
        <>
          <Text mt={2} color={"#767473"} fontSize={"14px"} mb={1}>
            {"Refill / Bulk"}
          </Text>
          <Box>
            {refillVariants.map(([key, value], i) => (
              <Variant
                key={key}
                title={key}
                options={value as any}
                isOpen={pickedVariant === i + regularVariants.length}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleClick(i + regularVariants.length);
                }}
                autoDiscount={autoDiscount}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};
